import { WashVehiclesQueryArgs } from '@/apps/washing/types/IWashing';

/**
 * Serialises the cleaning-list / next-departures filters the way the backend
 * binds them: one repeated `ContractId` / `MonitoredDepotId` entry per id
 * (same wire format Health Check uses for its own repeated filters).
 *
 * Returns `undefined` rather than empty search params when nothing is
 * selected, so an unfiltered read is byte-identical to the request the
 * dashboard sent before filtering existed — no trailing `?`, and the existing
 * e2e route globs keep matching.
 */
export const buildWashQueryParams = (
  args: WashVehiclesQueryArgs | void
): URLSearchParams | undefined => {
  if (!args) {
    return undefined;
  }

  const searchParams = new URLSearchParams();
  args.contractIds?.forEach((id) => {
    searchParams.append('ContractId', String(id));
  });
  args.monitoredDepotIds?.forEach((id) => {
    searchParams.append('MonitoredDepotId', String(id));
  });

  return Array.from(searchParams.keys()).length > 0 ? searchParams : undefined;
};
